import React, {useEffect} from 'react';
import {
  moveNextPage,
  backToChooseNumberPage,
  setCurrentPhoneNumberId,
  setCurrentPhone,
  setModeType,
  setPhoneListData,
  setFirstPage,
  setIsCurrentPhoneLoad,
  setIsNumberChosen,
  resetState,
} from './esimBlockSlice';
import {connect} from 'react-redux';
import SliceMiddleware from './sliceMiddleware';
import OperationStages from './OperationStages';

const EsimMainComponent = (props) => {
  const stages = OperationStages(props);
  let sliceMiddleware = new SliceMiddleware(props, stages);
  let views = sliceMiddleware.getViews();
  useEffect(() => {
    return () => {
      props.resetState();
    };
  }, []);
  return <div className='main-esim-container'>{React.createElement(views[props.currentStage].stageName)}</div>;
};

const mapStateToProps = (state) => {
  return {
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    currentStage: state.esim.currentStage,
    phoneDataList: state.esim.phoneDataList,
    modeType: state.esim.modeType,
    currentPhone: state.esim.currentPhone,
    isCurrentPhoneLoad: state.esim.isCurrentPhoneLoad,
    niudDataList: state.esim.niudDataList,
    saleDataList: state.esim.saleDataList,
    isNumberChosen: state.esim.isNumberChosen,
  };
};

const mapDispatchToProps = {
  moveNextPage,
  backToChooseNumberPage,
  setCurrentPhoneNumberId,
  setCurrentPhone,
  setModeType,
  setPhoneListData,
  setFirstPage,
  setIsCurrentPhoneLoad,
  setIsNumberChosen,
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(EsimMainComponent);
